import styled, { createGlobalStyle, css } from "styled-components";
import { device } from "./BreakPoints";
import fontsCss from "./fonts.module.css";

export const GlobalStyles = createGlobalStyle`
 ${fontsCss} 
*{
  scroll-behavior: smooth;

}
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-size: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  text-rendering: optimizeSpeed;
  background-color: #0a192f;
  font-family: var(--font-sans);
  
}
body::-webkit-scrollbar {
  width: 12px;
}
 
body::-webkit-scrollbar-track {
  background: var(--navy);
}
 
body::-webkit-scrollbar-thumb {
  background-color: var(--dark-slate);
    border: 3px solid var(--navy);
    border-radius: 10px;
}
main {
  padding: 0px 150px;
}
h1,
h2,
h3,
h4,
h5,
h6
 {
  margin: 0px 0px 10px;
    font-weight: 600;
    color: var(--lightest-slate);
    line-height: 1.1;
}
p{
  color: var(--slate);
}
button {
  border: none;
  background-color: transparent;
  font-family: inherit;
  padding: 0;
  cursor: pointer;
}
/* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
ul[role="list"],
ol[role="list"] {
  list-style: none;
}
li {
  list-style-type: none;
}
/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}
/* A elements that don't have a class get default styles */
a{
  text-decoration: none;
  color: inherit;
}
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img,
picture {
  max-width: 100%;
  display: block;
}

@media ${device.lg} {
  main{
    padding: 0px 100px;
  }

  /* work  */
  .project-list-item .project-content {
    grid-column: 1 / 9;
}
.project-list-item:nth-of-type(2n + 1) .project-content {
  grid-column: 5 / -1;
}
}


/* tablet screen  */
@media ${device.mdM} {
  main{
    padding: 0px 50px;
  }
  /* work  */
  .project-list-item {
  margin-bottom: 70px;
  box-shadow: 0 10px 30px -15px var(--navy-shadow);
}

.project-list-item .project-content {
  display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    grid-column: 1 / -1;
    padding: 40px 40px 30px;
    z-index: 5;
    background-color: #0b1c31;
    opacity: .6;
}
.project-list-item:nth-of-type(2n + 1) .project-content {
  position: relative;
  grid-column: 1 / -1;
    padding: 40px 40px 30px;
    text-align: left;
}
.project-list-item .project-description {
  padding: 0px;
  background: inherit;
  box-shadow: none;

}
.project-list-item:nth-of-type(2n + 1) .project-tech-list {
  justify-content: flex-start;
}
.project-list-item:nth-of-type(2n + 1) .project-links {
  justify-content: flex-start;
  
}
 /* img  */
.project-list-item .project-image {
  height: 100%;
  opacity: 0.25;
    
}
.project-list-item:nth-of-type(2n + 1) .project-image {
  grid-column: 1 / -1;
}

}

// mobile screen
@media ${device.mobileL} {
  main{
    padding: 0px 25px;
  }

  /* work */
  .project-list-item .project-content {
    padding: 25px 25px 20px;
}
}


/* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }

  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}`;
